// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import * as multiviewActionCreators from '../../actions/multiview';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';
import useMultiviewMatchContext from '../../hooks/useMultiviewMatchRouteContext';

import MultiviewBlockMatch from './MultiviewBlockMatch';
import selectMultiviewBlockMatchProps from './MultiviewBlockMatch.selector';

type MultiviewBlockMatchContainerProps = {
  visible: boolean;
};

const MultiviewBlockMatchContainer = (ownProps: MultiviewBlockMatchContainerProps) => {
  const { matchId } = useMultiviewMatchContext();

  const selectorProps = useMemo(() => ({ matchId }), [matchId]);
  const selectedProps = useSelector((state) => selectMultiviewBlockMatchProps(state, selectorProps));

  const actionsProps = useBindActionsCreator(multiviewActionCreators);

  const otherProps = { matchId };

  const enhancedProps = useMergeProps({ selectedProps, actionsProps, ownProps, otherProps });

  return <MultiviewBlockMatch {...enhancedProps} />;
};

export default MultiviewBlockMatchContainer;
